/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Included_2Inputs */

const tr_landing_pricing_included_2 = /** @type {(inputs: Landing_Pricing_Included_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSL + AES-256`)
};

const en_landing_pricing_included_2 = /** @type {(inputs: Landing_Pricing_Included_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSL + AES-256`)
};

const de_landing_pricing_included_2 = /** @type {(inputs: Landing_Pricing_Included_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSL + AES-256`)
};

const ru_landing_pricing_included_2 = /** @type {(inputs: Landing_Pricing_Included_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSL + AES-256`)
};

/**
* | output |
* | --- |
* | "SSL + AES-256" |
*
* @param {Landing_Pricing_Included_2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricing_included_2 = /** @type {((inputs?: Landing_Pricing_Included_2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Included_2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_included_2(inputs)
	if (locale === "de") return de_landing_pricing_included_2(inputs)
	if (locale === "ru") return ru_landing_pricing_included_2(inputs)
	return tr_landing_pricing_included_2(inputs)
});